module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-4-2e77db7ae9c4a0231194960611570110.svg";